import React, { useState, useEffect, useRef } from 'react';
import { HeaderGlobal, Breadcrumb } from 'src/components';
import { Helmet } from "react-helmet";
import { useSelector, useDispatch } from 'react-redux';
import {
    setDataSuggestionCategories, 
    setDataDatasetCategories, 
    setFormKritikSaran,
    apiSaveUserSuggestion
} from 'src/config/redux/action';
import { useAlert } from "react-alert";

const KritikSaran = ({ ...props }) => {
    const alert = useAlert();
    const {formKritikSaran, dataSuggestionCategories, dataDatasetCategories} = useSelector(state => state.kritikSaranReducer)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setDataSuggestionCategories())
        dispatch(setDataDatasetCategories())
    }, [dispatch])

    const btnKirim = async () => {
       await dispatch(apiSaveUserSuggestion(formKritikSaran, alert));
    }

    return (
        <>
            <Helmet>
                <meta charSet='utf-8' />
                <title>{`Kritik dan Saran | Portal Satu Data Kabupaten Sigi`}</title>
                <meta name='description' content={`Kritik dan Saran | Portal Satu Data Kabupaten Sigi`} />
            </Helmet>
            <div className="site-main">
                <HeaderGlobal />

                <section className="ttm-row aboutus-section ttm-bgcolor-grey clearfix">
                    <div className="container-xl mt-4 res-767-mt-0">

                        {/* BREADCUMB */}
                        <Breadcrumb crumbs={props.crumbs} />
                        {/* BREADCUMB */}

                        <section className="sidebar ttm-sidebar ttm-bgcolor-grey clearfix">
                            <div className="container-xl">
                                <div className="row" >
                                    <div className="col-lg-4">
                                        <div className="spacing-10 ttm-bgcolor-primary ttm-bg ttm-col-bgcolor-yes ttm-right-span">
                                            <div className="section-title with-desc clearfix">
                                                <div className="title-header">
                                                    <h2 className="title">Deskripsi Saran Dataset</h2>
                                                </div>
                                                <div>
                                                    Anda dapat mengajukan Data yang dibutuhkan di halaman ini tentang Seluruh Unit Kerja Pemerintah Kabupaten Sigi.
                                                    <br />
                                                    <br />
                                                    Jika Anda memiliki saran data yang dibutuhkan masyarakat tentang Seluruh Unit Kerja Pemerintah Kabupaten Sigi, silahkan isi kolom ini
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="spacing-10 ttm-bgcolor-grey ttm-bg ttm-col-bgcolor-yes ttm-right-span">
                                            <div className="ttm-col-wrapper-bg-layer ttm-bg-layer">
                                                <div className="ttm-bg-layer-inner" />
                                            </div>
                                           
                                            <div className="section-title with-desc clearfix">
                                                <div className="title-header">
                                                    <h5>Saran Dataset</h5>
                                                    <h2 className="title">Formulir</h2>
                                                </div>
                                            </div>
                                            <form id="ttm-quote-form" className="row ttm-quote-form clearfix" method="post" action="#">
                                                <div className="col-sm-6 col-md-6">
                                                    <div className="form-group">
                                                        <input name="Name" type="text" className="form-control bg-white" placeholder="Nama lengkap*" required="required" value={formKritikSaran.Name} onChange={(e) => dispatch(setFormKritikSaran("Name", e.target.value) ) } />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6 col-md-6">
                                                    <div className="form-group">
                                                        <input name="Email" type="text" placeholder="Email*" required="required" className="form-control bg-white" value={formKritikSaran.Email} onChange={(e) => dispatch(setFormKritikSaran("Email", e.target.value) ) } />
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-12">
                                                    <div className="form-group">
                                                        <input name="Mobile" type="number" placeholder="No Telepon yang Bisa di Hubungi*" required="required" className="form-control bg-white" value={formKritikSaran.Mobile} onChange={(e) => dispatch(setFormKritikSaran("Mobile", e.target.value) ) } />
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-12">
                                                    <div className="form-group">
                                                        <select name="UserSuggestionCategoryId" className="form-control bg-white" value={formKritikSaran.UserSuggestionCategoryId} onChange={(e) => dispatch(setFormKritikSaran("UserSuggestionCategoryId", e.target.value))}>
                                                            <option>Pilih Kategori Pemohon*</option>
                                                            {
                                                                dataSuggestionCategories &&
                                                                dataSuggestionCategories.map((v, i) => {
                                                                    return (
                                                                        <option key={i} value={v.Id}>{v.Name}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-12">
                                                    <div className="form-group">
                                                        <select name="DatasetCategoryId" className="form-control bg-white" value={formKritikSaran.DatasetCategoryId} onChange={(e) => dispatch(setFormKritikSaran("DatasetCategoryId", e.target.value))}>
                                                            <option>Topik Dataset yang Disarankan*</option>
                                                            {
                                                                dataDatasetCategories &&
                                                                dataDatasetCategories.map((v, i) => {
                                                                    return (
                                                                        <option key={i} value={v.Id}>{v.Name}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-sm-12 col-md-12">
                                                    <div className="form-group">
                                                        <textarea name="DatasetSuggestion" rows={5} placeholder="Tolong jelaskan Mengenai Dataset yang Anda Sarankan..." required="required" value={formKritikSaran.DatasetSuggestion} className="form-control bg-white" defaultValue={""} onChange={(e) => dispatch(setFormKritikSaran("DatasetSuggestion", e.target.value))} />
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-12">
                                                    <div className="form-group">
                                                        <textarea name="DatasetReason" rows={5} placeholder="Alasan Mengapa Dataset Tersebut Penting..." required="required" className="form-control bg-white" defaultValue={""} value={formKritikSaran.DatasetReason} onChange={(e) => dispatch(setFormKritikSaran("DatasetReason", e.target.value))}  />
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="text-left">
                                                        <button type="button" onClick={() => btnKirim()} id="submit" className="mt-3 ttm-btn ttm-btn-size-md ttm-bgcolor-skincolor" value>
                                                            Kirim Pesan
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </section>
                    </div>
                </section>
            </div>
        </>
    );
};

export default KritikSaran;